const login = {
   // seems to be deprecated >> see public/conf/login-messages.js
   useKeycloak: true,
   maintenance: {
    show: false,
    html: '<p>Liebe Teilnehmende:</p><p>aufgrund von Security-Einstellungen auf unserem sgd-OnlineCampus kann es aktuell vermehrt dazu kommen, dass der Login nicht wie gewohnt funktioniert. Damit Sie schnell und unkompliziert den Online Campus erreichen können, löschen Sie bitte einmal Ihren Browser-Cache und stellen Sie sicher, dass Sie den Campus über die URL <a style="text-decoration: none;" href="https://www.sgd-campus.de">www.sgd-campus.de</a><span> aufrufen. Dann sollte der Login reibungslos funktionieren.</p><p>Bitte entschuldigen Sie die Umstände,</p><p>Ihr sgd-OnlineCampus-Team</p>'
   },
   footer: [{
     label: 'Studiengemeinschaft Darmstadt',
     uri: 'https://www.sgd.de',
     target: '_blank'
   }, {
     label: 'Impressum',
     uri: 'https://www.sgd.de/impressum.html',
     target: '_blank'
   }, {
     label: 'Datenschutz',
     uri: 'https://www.sgd-campus.de/c/datenschutz',
     target: '_blank'
   }]
}
export default { login }
